import React from 'react';
import {Route, Routes} from 'react-router';

import {Login} from './login';
import {Registration} from './registration';
import {ResetPassword} from './resetPassword';
import {Signup} from './signup';

export default () => {
  return (
    <Routes>
      <Route path="signin/*" element={<Login />} />
      <Route path="signup/*" element={<Signup />} />
      <Route path="reset_password/*" element={<ResetPassword />} />
      <Route path="registration/*" element={<Registration />} />
    </Routes>
  );
};
